
import { useState, useEffect, React } from "react";
//import { DataTable, TableContainer, Table, TableHead, TableRow, TableHeader, TableBody, TableCell, Pagination } from '@carbon/react';
import DataTable from 'react-data-table-component';

const headers = [
    {   name: 'XML', selector: rows=>rows['xml'], width: '70px' },
    {   name: 'PDF',  selector: rows=>rows['pdf'], width: '70px' },
    {   name: 'Fecha de pago', selector: rows=>rows['fePago'] },
    {   name: 'RFC empleado', selector: rows=>rows['rfcEmpleado'], width: '140px', wrap: true },
    {   name: 'Empleado', selector: rows=>rows['empleado'], width: '170px', wrap: true },
    {   name: 'Núm. empleado', selector: rows=>rows['numEmpleado'], width: '140px', wrap: true },
    {   name: 'Tipo nómina', selector: rows=>rows['tipoNom'], width: '120px', wrap: true },
    {   name: 'Fecha inicial pago', selector: rows=>rows['feIniPago'], width: '150px', wrap: true },
    {   name: 'Fecha final pago', selector: rows=>rows['feFinPago'], width: '150px', wrap: true },
    {   name: 'Núm. días pagados ', selector: rows=>rows['numDiasPagados'], width: '160px', wrap: true },
    {   name: 'Total percepciones', selector: rows=>rows['totalPercep'], width: '160px', wrap: true },
    {   name: 'Total deducciones', selector: rows=>rows['totalDeducc'], width: '160px', wrap: true },
    {   name: 'Total otros pagos', selector: rows=>rows['totalOtrosPagos'], width: '150px', wrap: true },
    {   name: 'Subtotal', selector: rows=>rows['subtotal'], width: '90px', wrap: true },
    {   name: 'Total', selector: rows=>rows['total'], width: '90px', wrap: true },
    {   name: 'Moneda', selector: rows=>rows['moneda'], width: '90px', wrap: true  },
    {   name: 'UUID', selector: rows=>rows['uuid'], width: '200px', wrap: true },
    {   name: 'RFC emisor', selector: rows=>rows['rfcEmisor'], width: '130px', wrap: true },
    {   name: 'Nombre emisor', selector: rows=>rows['nombreEmisor'], width: '170px', wrap: true },
    {   name: 'Fecha emisión', selector: rows=>rows['feEmisión'], width: '150px', wrap: true },
];


  
const RecibosTable = ({ rows }) => {
  /*
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    useEffect(() => {
        setItems(rows.slice(0, itemsPerPage))
    }, []);

    function onChangeTable(e) {
        setItemsPerPage(e.pageSize);
        setPage(e.page)
        setItems(rows.slice((e.page * e.pageSize) - e.pageSize, (e.page * e.pageSize)))
    }
   
    return (
        <div>
            <DataTable rows={rows} headers={headers} render={({
                rows,
                headers,
                getHeaderProps,
                getTableProps }) => (

                <TableContainer>
                    <Table {...getTableProps()} size="sm">
                        <TableHead>
                            <TableRow>
                                {headers.map((header) => (
                                    <TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.id}>
                                    {row.cells.map((cell) => (
                                        <TableCell key={cell.id}>{cell.value}</TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )} />
           
            <Pagination
                backwardText="Previous page"
                forwardText="Next page"
                itemsPerPageText="Items per page:"
                onChange={(e) => onChangeTable(e)}
                page={page}
                pageSize={itemsPerPage}
                pageSizes={[
                    10,
                    20,
                    30,
                    40,
                    50
                ]}
                size="md"
                totalItems={rows.length}
            />
           
        </div>
    );
};
*/
    return (
        <DataTable
            title=""
            columns={[...headers]}
            data={rows}
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
            highlightOnHover
            searchable
            noDataComponent="No hay datos disponibles"
            paginationComponentOptions={{
                rowsPerPageText: 'Filas por página:',
                rangeSeparatorText: 'de',
                noRowsPerPageText: 'Sin filas por página',
            }}
        />
    );
};

export default RecibosTable;